(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["geiss-geschmackskompass"] && !Shopify.designMode) return;
  try {
    
  class GeissKompass extends HTMLElement {
    connectedCallback() {
      this.zeilen = Array.from(this.querySelectorAll('.geiss-kompass__zeile'));
      this.punkte = Array.from(this.querySelectorAll('.geiss-kompass__punkt'));
      this.aktiv = null;
      if (!this.zeilen.length) return;

      this.zeilen.forEach((zeile) => {
        const key = zeile.dataset.key;
        zeile.addEventListener('mouseenter', () => this.setActive(key));
        zeile.addEventListener('focusin', () => this.setActive(key));
        zeile.addEventListener('mouseleave', () => this.setActive(null));
        zeile.addEventListener('focusout', () => this.setActive(null));
      });

      /* Punkte antippbar: derselbe Aktiv-Zustand wie beim Hovern der Zeile,
         aber ohne Navigation. Bewusst nur Zeigerereignisse und kein
         tabindex — die Punkte liegen in einem aria-hidden-Bereich.
         Tastatur und Screenreader nutzen die Liste. Zweiter Tipp auf
         denselben Punkt hebt die Hervorhebung wieder auf. */
      this.punkte.forEach((punkt) => {
        punkt.addEventListener('click', (event) => {
          event.preventDefault();
          const key = punkt.dataset.key;
          this.setActive(this.aktiv === key ? null : key);
        });
      });
    }

    setActive(key) {
      this.aktiv = key;
      this.zeilen.forEach((z) => z.classList.toggle('is-active', z.dataset.key === key));
      this.punkte.forEach((p) => p.classList.toggle('is-active', p.dataset.key === key));
    }
  }

  if (!customElements.get('geiss-kompass')) {
    customElements.define('geiss-kompass', GeissKompass);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geiss-usp-bar"] && !Shopify.designMode) return;
  try {
    
  class UspBar extends HTMLElement {
    connectedCallback() {
      this.animationEnabled = this.dataset.animation === 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!this.animationEnabled || this.reducedMotion) {
        this.revealAll();
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.runAnimation();
            this.observer.disconnect();
            this.observer = null;
            return;
          }
        }
      }, { threshold: 0.3 });

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }

    revealAll() {
      this.querySelectorAll('.usp-bar__item').forEach((item) => {
        item.classList.add('is-visible');
      });
    }

    runAnimation() {
      const items = this.querySelectorAll('.usp-bar__item');
      items.forEach((item, i) => {
        const eyecatcher = item.querySelector('.usp-bar__eyecatcher');
        const value = eyecatcher ? (eyecatcher.dataset.eyecatcher || eyecatcher.textContent) : '';
        const match = value.match(/^(\D*)(\d+)(\D*)$/);
        if (eyecatcher && match) {
          eyecatcher.textContent = match[1] + '0' + match[3];
        }

        setTimeout(() => {
          item.classList.add('is-visible');
          if (eyecatcher && match) {
            this.animateNumber(eyecatcher, match[1], parseInt(match[2], 10), match[3]);
          }
        }, i * 100);
      });
    }

    animateNumber(el, prefix, target, suffix) {
      const duration = 800;
      const start = performance.now();
      const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

      const step = (now) => {
        const elapsed = now - start;
        const t = Math.min(elapsed / duration, 1);
        const current = Math.round(target * easeOutCubic(t));
        el.textContent = prefix + current + suffix;
        if (t < 1) requestAnimationFrame(step);
      };

      requestAnimationFrame(step);
    }
  }

  if (!customElements.get('usp-bar')) {
    customElements.define('usp-bar', UspBar);
  }

  } catch(e) { console.error(e); }
})();
})();
